import onSpotlightRollupDismissed from '../actions/onSpotlightRollupDismissed';
import isSpotlightItem from '../selectors/isSpotlightItem';
import getStore from '../store/store';
import { isFeatureEnabled } from 'owa-feature-flags';
import { userMailInteractionAction } from 'owa-mail-actions';
import { orchestrator } from 'satcheljs';
import {
    getAcknowledgedSpotlightItemsCache,
    isItemInAcknowledgedSpotlightItemsCache,
    updateAcknowledgedSpotlightItemsCache,
} from '../utils/cacheUtils';

/**
 * This orchestrator subscribes to interactions with mail items and saves item
 * identifying info (itemId, conversationId, rowKey) to local storage so we can
 * later check if a particular Spotlight item has been interacted with or not.
 */
orchestrator(userMailInteractionAction, actionMessage => {
    if (!isFeatureEnabled('tri-spotlight')) {
        return;
    }

    const { triageContext = {} } = actionMessage;
    let { itemIds = [], conversationIds = [], rowKeys = [] } = triageContext;

    // Remove any bad values
    itemIds = itemIds.filter(id => !!id);
    conversationIds = conversationIds.filter(id => !!id);
    rowKeys = rowKeys.filter(rowKey => !!rowKey);

    if (itemIds.length === 0 && conversationIds.length === 0 && rowKeys.length === 0) {
        return;
    }

    const acknowledgedSpotlightItems = getAcknowledgedSpotlightItemsCache();

    itemIds.map((itemId: string) => {
        if (
            isSpotlightItem({ itemId }) &&
            !isItemInAcknowledgedSpotlightItemsCache({ itemId, acknowledgedSpotlightItems })
        ) {
            acknowledgedSpotlightItems.push({
                itemId,
            });
        }
    });

    conversationIds.map((conversationId: string) => {
        if (
            isSpotlightItem({ conversationId }) &&
            !isItemInAcknowledgedSpotlightItemsCache({ conversationId, acknowledgedSpotlightItems })
        ) {
            acknowledgedSpotlightItems.push({
                conversationId,
            });
        }
    });

    rowKeys.map((rowKey: string) => {
        if (
            isSpotlightItem({ rowKey }) &&
            !isItemInAcknowledgedSpotlightItemsCache({ rowKey, acknowledgedSpotlightItems })
        ) {
            acknowledgedSpotlightItems.push({
                rowKey,
            });
        }
    });

    updateAcknowledgedSpotlightItemsCache(acknowledgedSpotlightItems);
});

/**
 * This orchestrator marks all Spotlight items as acknowledged when Spotlight
 * rollup is dismissed.
 */
orchestrator(onSpotlightRollupDismissed, () => {
    const spotlightItems = getStore().spotlightItems;
    const acknowledgedSpotlightItems = getAcknowledgedSpotlightItemsCache();

    for (const spotlightItem of spotlightItems) {
        const { itemId, conversationId, rowKey } = spotlightItem;

        if (
            !isItemInAcknowledgedSpotlightItemsCache({
                itemId,
                conversationId,
                rowKey,
                acknowledgedSpotlightItems,
            })
        ) {
            acknowledgedSpotlightItems.push({
                itemId,
                conversationId,
                rowKey,
            });
        }
    }

    updateAcknowledgedSpotlightItemsCache(acknowledgedSpotlightItems);
});
